import { maxLength, checkRegex, lessThan, email } from 'utils/validation'

export default (fields = {}) => {
  const errors = {
    exchequerNumber: maxLength(6)(fields.exchequerNumber),
    vatNumber: maxLength(15)(fields.vatNumber) ||
      checkRegex(fields.vatNumber, /^[a-z0-9_ ]+$/i),
    gnippPercentage: lessThan(500)(fields.gnippPercentage),
    email: email(fields.email)
  }

  return errors
}
